<template>
  <v-container fill-height fluid align-start pa-0>
    <v-layout column>
      <div :class="getAssessmentCssClassByAge(assessment.age)">
        <!-- {{ assessment }} -->
        <div class="l-container mh-auto white--text assessment-name pa-4">
          <h1>
            <span class="name-small">{{ $t('LBL.ASSESSMENT') }}:</span><br>
            {{ $t('LBL.T_MONTHS', {AGE_MTH: assessment.age})}}
          </h1>
        </div>
      </div>

      <assessment-content :child="child" :assessment="assessment"
        ></assessment-content>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  UPDATE_APP_STEP,
  UPDATE_TOOLBAR_TITLE
} from '@/store/mutation-types'
import AssessmentMixin from '@/components/mixins/AssessmentMixin'
import AssessmentContent from '@/components/elements/AssessmentContent'

export default {
  name: 'AssessmentPage',
  components: {
    'assessment-content': AssessmentContent
  },
  computed: {
    child: function () {
      const childId = parseInt(this.$route.params.childId, 10)
      return this.userChildren.filter((child) => child.id === childId).pop()
    },
    assessment: function () {
      return Object.assign({},
        this.assessments && this.assessments[this.$route.params.age]
          ? this.assessments[this.$route.params.age]
          : {}
      )
    },
    ...mapState({
      appReady: state => state.appReady,
      userChildren: state => state.userChildren,
      assessments: state => state.assessments
    })
  },
  created () {
    this.updateAppStep(3)
    // if (this.assessment) {
    //   this.updateToolbarTitle(this.assessment.name)
    // }
  },
  data () {
    return {
    }
  },
  destroyed () {
    // this.updateToolbarTitle('')
  },
  methods: {
    ...mapMutations({
      updateAppStep: UPDATE_APP_STEP,
      updateToolbarTitle: UPDATE_TOOLBAR_TITLE
    })
  },
  mixins: [
    AssessmentMixin
  ],
  watch: {
    // appReady: function (appReady) {
    //   if (appReady) {
    //     this.updateToolbarTitle(this.assessment.name)
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.assessment-name {
  h1 {
    line-height: 32px;
    font-size: 24px;

    .name-small {
      font-size: 14.5px;
      line-height: 1.5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/AssessmentPage.vue